<template>
  <div>
    <div v-if="isMobile">
      <nav
        class="navbar fixed-top"
        style="background-color: #363166; height: 72px"
      >
        <div class="mobile-container">
          <div class="nav-brand">
            <img
              src="../../../public/DashLogo.png"
              alt=""
              class="mobile-logo"
            />
            <span class="greeting">Hello {{ this.user }}</span>
          </div>
          <div class="nav-actions">
            <button class="nav-btn" @click="createNewProfile">
              <i class="fa-solid fa-plus"></i>
            </button>
            <button class="nav-btn" @click="logUserOut">
              <i class="fa-solid fa-sign-out"></i>
            </button>
          </div>
        </div>
      </nav>
      <div style="height: 72px"></div>
    </div>
    <div v-else>
      <nav
        class="navbar navbar-expand-lg fixed-top"
        style="background-color: #363166; height: 56px"
      >
        <div class="desktop-container">
          <div class="nav-brand">
            <img
              src="../../../public/DashLogo.png"
              alt=""
              class="desktop-logo"
            />
            <h5 class="desktop-greeting">Hello {{ this.user }}</h5>
          </div>
          <div class="nav-actions">
            <button
              class="btn btn-primary desktop-btn"
              @click="createNewProfile"
            >
              Create Profile
            </button>
            <button class="btn btn-primary desktop-btn" @click="logUserOut">
              Logout
            </button>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    user: String,
  },
  data() {
    return {
      menu: [
        {
          header: true,
          title: 'Main Navigation',
          hiddenOnCollapse: true,
        },
        {
          href: '/',
          title: 'Dashboard',
          icon: 'fa fa-user',
        },
        {
          href: '/charts',
          title: 'Charts',
          icon: 'fa fa-chart-area',
          child: [
            {
              href: '/charts/sublink',
              title: 'Sub Link',
            },
          ],
        },
      ],
    }
  },
  methods: {
    logUserOut() {
      localStorage.removeItem('jwt')
      localStorage.removeItem('user')
      this.$router.push('/')
    },
    createNewProfile() {
      this.$router.push('/Recruit/Dashboard/Website')
    },
    myActivities() {
      this.$router.push('/Recruit/Dashboard/Website')
    },
  },
  computed: {
    isMobile: function () {
      var check = false
      ;(function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a,
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
            a.substr(0, 4),
          )
        )
          check = true
      })(navigator.userAgent || navigator.vendor || window.opera)
      return check
    },
  },
}
</script>

<style scoped>
.v-sidebar-menu {
  background-color: #363166 !important;
}
.btn-primary {
  background-color: #19d412 !important;
  border-color: #19d412 !important;
  padding: 4px 12px !important;
  font-size: 14px !important;
}
.form-check-input:checked {
  background-color: #19d412 !important;
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.form-check-input:hover .form-check-input:active,
.form-check-input:focus {
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.btn-primary:hover,
.btn-primary:active,
.btn-primary:focus {
  background-color: #16b910 !important;
  border-color: #16b910 !important;
  box-shadow: none !important;
}
.form-control:-webkit-autofill,
.form-control:-webkit-autofill:hover,
.form-control:-webkit-autofill:focus {
  border-color: #19d412 !important;
  box-shadow: 0 0 0 1000px rgb(255, 255, 255) inset !important;
  background-color: #ffffff !important;
}
.form-control:focus,
.form-control:visited,
.form-control:active,
.form-control:hover,
.form-control:checked {
  border-color: #19d412 !important;
  background-color: #ffffff !important;
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.border,
.border-primary {
  border-color: #19d412 !important;
  box-shadow:
    inset 0 1px 1px rgba(0, 0, 0, 0.075),
    0 0 8px rgba(25, 212, 18, 0.6) !important;
}
.b-card,
.b-card:hover {
  border: 1px solid #19d412 !important;
}
#nav {
  padding: 30px;
}
#nav a {
  font-weight: bold;
  color: #2c3e50;
}
#nav a.router-link-exact-active {
  color: #42b983;
}
.navbar-brand {
  position: absolute;
  left: calc(50% - 65px);
  display: block;
}
.grow {
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.1);
}
.navbar {
  padding: 0 !important;
  z-index: 1030;
}
.nav-item img {
  width: auto !important;
  height: auto !important;
}

/* Mobile-specific styles */
.mobile-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}

.nav-brand {
  display: flex;
  align-items: center;
  gap: 16px;
}

.mobile-logo {
  height: 32px;
  width: auto;
}

.greeting {
  color: white;
  font-size: 1rem;
  font-weight: 500;
}

.nav-actions {
  display: flex;
  gap: 12px;
}

.nav-btn {
  background: #19d412;
  border: none;
  color: white;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
}

.nav-btn:active {
  background: #16b910;
}

/* Add top margin to main content when on mobile */
@media (max-width: 768px) {
  :deep(.main-content) {
    margin-top: 56px !important;
    padding-top: 1rem;
  }

  .container-fluid {
    padding: 0 !important;
  }
}

@media (max-width: 380px) {
  .mobile-nav-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 10px;
  }

  .mobile-greeting {
    margin-bottom: 4px;
  }

  .mobile-buttons {
    width: 100%;
  }

  .mobile-btn {
    flex: 1;
  }
}

/* Desktop styles */
.desktop-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  padding: 0 20px;
}

.desktop-logo {
  height: 28px;
  width: auto;
  margin-right: 15px;
}

.desktop-greeting {
  color: white;
  margin: 0;
  font-size: 1rem;
  font-weight: 500;
}

.desktop-btn {
  margin-left: 10px;
  padding: 4px 12px;
  font-size: 14px;
}
</style>
